if (!customElements.get("logo-carousel")) {
  customElements.define(
    "logo-carousel",
    class LogoCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector("[data-track]");
        this.dots = this.querySelector("[data-dots]");
        if (!this.track) return;

        this.track.addEventListener("scroll", () => this.update(), {
          passive: true,
        });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);

        this.dots?.addEventListener("click", (event) => {
          const dot = event.target.closest("button[data-page]");
          if (dot) this.goTo(Number(dot.dataset.page));
        });

        // Autoplay waits while the pointer or focus is inside and stops for good after a touch.
        this.paused = false;
        this.addEventListener("mouseenter", () => (this.paused = true));
        this.addEventListener("mouseleave", () => (this.paused = false));
        this.addEventListener("focusin", () => (this.paused = true));
        this.addEventListener("focusout", () => (this.paused = false));
        this.addEventListener("touchstart", () => this.stopAutoplay(), {
          passive: true,
        });

        this.update();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.resizeObserver?.disconnect();
      }

      startAutoplay() {
        const delay = Number(this.dataset.autoplay);
        const reduceMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;
        if (!delay || reduceMotion) return;

        this.timer = setInterval(() => {
          if (this.paused || document.hidden) return;
          const pages = this.getPages();
          if (pages < 2) return;
          const next = this.getCurrentPage() + 1;
          this.goTo(next >= pages ? 0 : next);
        }, delay);
      }

      stopAutoplay() {
        clearInterval(this.timer);
        this.timer = null;
      }

      // Pages are one track width each; the last page is wherever the track stops scrolling.
      getPages() {
        const { scrollWidth, clientWidth } = this.track;
        return Math.max(1, Math.ceil(scrollWidth / clientWidth - 0.05));
      }

      getCurrentPage() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const pages = this.getPages();
        if (scrollLeft >= scrollWidth - clientWidth - 2) return pages - 1;
        return Math.min(pages - 1, Math.round(scrollLeft / clientWidth));
      }

      goTo(page) {
        const reduceMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;
        this.track.scrollTo({
          left: page * this.track.clientWidth,
          behavior: reduceMotion ? "auto" : "smooth",
        });
      }

      update() {
        if (!this.dots) return;
        const pages = this.getPages();
        const current = this.getCurrentPage();

        if (this.dots.childElementCount !== (pages > 1 ? pages : 0)) {
          const label = this.dots.dataset.dotLabel || "";
          this.dots.innerHTML = "";
          if (pages > 1) {
            for (let i = 0; i < pages; i++) {
              const dot = document.createElement("button");
              dot.type = "button";
              dot.dataset.page = i;
              dot.setAttribute("aria-label", label.replace("__n__", i + 1));
              this.dots.appendChild(dot);
            }
          }
        }
        Array.from(this.dots.children).forEach((dot, i) => {
          const active = i === current;
          dot.classList.toggle("is-active", active);
          dot.setAttribute("aria-current", active ? "true" : "false");
        });
      }
    },
  );
}
